import i18n from 'i18next';

export default function formattedAmount(amount, currency) {
    try {
        const formatter = new Intl.NumberFormat(i18n.language.replace("_", "-"), {
            style: 'currency',
            currency,
            currencyDisplay: 'narrowSymbol',
        });

        // If amount is provided (even if it is 0) format normally
        if (amount !== null && amount !== undefined && amount !== '') {
            return formatter.format(amount);
        }
        // If not return only the currency symbol
        return formatter.format(0).replace(/[0-9.,\s]/g, '').trim();

    } catch (error) {
        console.error(error);
        return "";
    }
}
